import React, { useEffect, useState } from 'react';
import { Waypoint } from 'react-waypoint';
import Map from './Map';
import styled from 'styled-components';

export default function Scroll( props ){
    const Steps = {
        'CHICAGO': [
            {
                stepNumber:0,
                text:<p>All our US COVID deaths in Millenium Park.<br/><br/>
                
                Scroll to begin.</p>,
            },
            {
                stepNumber:1,
                text:<p>2 months after the first cases were detected in the US, the death tolls was at 360. 
                    These deaths concentrated in some of the first outbreak locations in the US ― the NYC metro region and King County, Washington were early hotspots.
                    <br/><br/>                
                    In Chicago, this might be a crowd around the Bean.</p>,
            },
            {
                stepNumber:2,
                text:<p>Just a week later, the death toll rose by over 6 times to 2,300. At this time, the first wave was pummeling the northeastern US and other major
                metropolitan hubs. If not already under the strongest stay-at-home orders of the pandemic, this is when "peak lockdown" commenced for much of the country.
                <br/><br/>            
                2,300 people pack the plaza around Cloudgate.</p>,
            },
            {
                stepNumber:3,
                text:<p>Just another week later in early April, the death toll is near 11,000. 
                    <br/><br/>
                    We can barely fit everyone in the bandshell and lawn ― standing room only.</p>,
            },
            {
                stepNumber:4,
                text:<p>
                    By May, the initial first shock had passed and case rates slowly declined as life carried on in an increasingly remote, isolated world. US deaths attributed 
                    to COVID-19 have now exceeded 75,000.
                    <br/><br/>
                    This is enough to pack most of Maggie Daily Park ― near the skating ribbon and climbings walls is now shoulder to shoulder.
                </p>,
            },
            {
                stepNumber:5,
                text:<p>
                    By late Summer, the intense second wave dwarfed the first one. Deaths have more than doubled to above 160,000 people. 
                    <br/><br/>
                    From the Rose Gardens to Buckingham fountain, Grant Park's plaza around is now occupied with crowds much like the bandshell's standing room capacity.
                </p>,
            },
            {
                stepNumber:6,
                deathCount:props.sums[props.sums.length-1]||500_000,
                text:<p>
                    Over the coming months, the death toll more than tripled. <br/><br/>
                    Today we have lost <u>{props.sums && props.sums[props.sums.length-1].toLocaleString('en')}</u> people.
                    <br/><br/>
                    When the death toll reached <i>just</i> 100,000 it was described as incalculable. Now, it is nearly incomprehensible.  
                </p>,
            }
        ], 'DC': [
            {
                stepNumber:0,
                text:<p>All our US COVID deaths in the National Mall.
                    <br/><br/>
                    Scroll to begin.</p>,
            },
            {
                stepNumber:1,
                text:<p>
                    By early April of 2020, the death toll attributed to COVID-19 in the US is over 10,000. Standing shoulder to shoulder, this crowd might entirely fill
                    one of the lawns on the East side of the Mall.
                </p>,
            },
            {
                stepNumber:2,
                text:<p>
                    Within a week, the number lost reaches 25,000. Many states are now in the strongest lockdown they will experience during the pandemic.
                    A congregation fills and surrounds the Lincoln Memorial and its public plaza.
                </p>,
            },
            {
                stepNumber:3,
                text:<p>
                    By late May, over 100,000 people have died of COVID-19. Standing along both sides of the reflecting pool, this is a dense crowd.
                </p>
            },
            {
                stepNumber:4,
                text:<p>
                    By late September, the number has doubled to 200,000. The intense Summer wave heavily impacted Southern states across the sun belt and elsewhere, and 
                    the impact was not felt equally.
                    <br/><br/>The crowd stretches the full length of the reflecting pool.
                </p>,
            },
            {
                stepNumber:5,
                text:<p>
                    In Mid-December, just before the Winter holidays, we reach a new high of 300,00 losses. 
                    <br/><br/>
                    This many people might fill the grounds of the Washington Monument.
                </p>,
            },
            {
                stepNumber:6,
                text:<p>
                    Over the coming months, the death toll more than tripled. <br/><br/>
                    Today we have lost <u>{props.sums && props.sums[props.sums.length-1].toLocaleString('en')}</u> people.
                    <br/><br/>
                    When the death toll reached <i>just</i> 100,000 it was described as incalculable. Now, it is nearly incomprehensible.  
                </p>,
            }
        ], 'STLOUIS': [
            {
                stepNumber:0,
                text:<p>All our US COVID deaths in Gateway Arch National Park.
                    <br/><br/>
                    Scroll to begin.</p>,
            },
            {
                stepNumber:1,
                text:<p>
                    By late March of 2020, the death count from COVID has reached over 1,000 people. Early outbreaks in the Northeast and around Seattle catch
                    cities, health systems, and communities by surprise.
                    <br/><br/>
                    On the North Side of Gateway Arch National Park near Laclede's Landing, a crowd fills a clearing along the trail.
                </p>,
            },
            {
                stepNumber:2,
                text:<p>
                    Roughly a week later, as lockdown measures transform the lives of many communities, the death toll reaches 7,500 lives lost. 
                    Struggles to equip health systems with respirators, find masks, and adequated cleaning supplies strike the country, and much of the world, off-guard.
                    <br/><br/>
                    The steps down to the Riverfront are crowded.
                </p>,
            },
            {
                stepNumber:3,
                text:<p>
                    Within another two weeks, the current count is over 30,000. Life has slowed to a crawl for many, and the reality of a much longer lockdown is beginning to set in.
                    <br/><br/>
                    Just past the old courthouse, Kleiner Plaza Park is shoulder to shoulder.
                </p>
            },
            {
                stepNumber:4,
                text:<p>
                    By late May, casualties from the pandemic in the United States are now in the six figures. We try to understand the magnitude of the losses, and celebrate 
                    the health care professionals and essential workers doing everything possible to mitigate the pandemic's effects. 
                    <br/><br/>
                    Across Gateway Arch National Park, from the two ponds and the arch, a solemn crowd forms.
                </p>,
            },
            {
                stepNumber:5,
                text:<p>
                    Four months later, 200,000 deaths figure across the United States. The Summer wave across the South and Sun Belt gives way to the
                    major wave to cover the Upper-Midwest and Heartland. Things only accelerate for some time.
                    <br/><br/>
                    The bulk of the park is covered.
                </p>,
            },
            {
                stepNumber:6,
                text:<p>
                    Over the coming months, the death toll more than doubled. <br/><br/>
                    Today we have lost <u>{props.sums && props.sums[props.sums.length-1].toLocaleString('en')}</u> people.
                    <br/><br/>
                    When the death toll reached <i>just</i> 100,000 it was described as incalculable. Now, it is nearly incomprehensible.  
                </p>,
            }
        ], 
        
        // Houston
        // 1 Wortham Fountain 5_000 4/1
        // 2 Water works 45_000 4/22
        // 3 Out to highway 85_000 5/14
        // 4 Other riverbank 175_000 8/21
        // 5 Through police memorial 360_000 1/6
        // 6 Today fill along river 
        'HOUSTON': [
            {
                stepNumber:0,
                text:<p>All our US COVID deaths in Buffalo Bayou Park.
                    <br/><br/>
                    Scroll to begin.</p>,
            },
            {
                stepNumber:1,
                text:<p>
                    By early April, close to three months after the initial cases of COVID-19 were detected in the US, we lose 5,000 people to the pandemic. The early months of
                    COVID catch many communities off-gaurd and unprepared. 
                    <br/><br/>
                    On the west side of Buffalo Bayou Park, these people gather around the Dandelion Fountain in a dense group.
                </p>,
            },
            {
                stepNumber:2,
                text:<p>
                    About three weeks later, the number is now 45,000. Strict lockdown measures persist for much of the country, and the reality of a longer-lived remote life is setting in.
                    <br/><br/>
                    Around the Water Works and the skatepark, the massive group might convene.
                </p>,
            },
            {
                stepNumber:3,
                text:<p>
                    Into mid-May, the initial wave of COVID-19 has slowed, but the death toll now reaches 85,000. Communities, businesses, and governments struggle to get much needed supplies
                    and handle the new demands of pandemic life. 
                    <br/><br/>
                    The crowd by the Water Works has extended, filling the bayou down to Memorial Drive.
                </p>
            },
            {
                stepNumber:4,
                text:<p>
                    Over the Summer, an intense wave of outbreaks in the Sun Belt takes an additional 90,000 lives, bringing the total to over 175,000 by late August. 
                    <br/><br/>
                    The southern bank of the bayou in Eleanor Tinsley Park is just as crowded as the north side. 
                </p>,
            },
            {
                stepNumber:5,
                text:<p>
                    In early January of 2021, 360,000 lives have now been lost. The crowd stretches beyond the Houston Police Department memorial and wraps in to 
                    the Washington Cemetary. 
                </p>,
            },
            {
                stepNumber:6,
                text:<p>
                    Over recent months, the death toll crested half a million. <br/><br/>
                    Today we have lost <u>{props.sums && props.sums[props.sums.length-1].toLocaleString('en')}</u> people.
                    <br/><br/>
                    When the death toll reached <i>just</i> 100,000 it was described as incalculable. Now, it is nearly incomprehensible.  
                </p>,
            }
        ],
        'NYC': [
            {
                stepNumber:0,
                text:<p>All our US COVID deaths in Central Park.
                    <br/><br/>
                    Scroll to begin.</p>,
            },
            { // 1 Obelisk 360 3/21
                stepNumber:1,
                text:<p>
                    2 months after the first cases were detected in the US, the death tolls was at 360. 
                    These deaths concentrated in some of the first outbreak locations in the US ― the NYC metro region and King County, Washington were early hotspots.
                    <br/><br/>                
                    In Central Park, The Obelisk near the Met draws a small crowd.</p>,
            },
            {// 2 Delacorte Theater 1_800 3/27
                stepNumber:2,
                text:<p>
                    Within another week, the death count is 1,800 and the Delacorte Theater is full seated.
                </p>,
            },
            {// 3 Bethesda Terrace 7_500 4/3
                stepNumber:3,
                text:<p>
                    One more week, in early April, the death toll has more than tripled to 7,500. Communities are scrambling to respond.
                    <br/><br/>
                    The Bethesda Terrace is now shoulder to shoulder.
                </p>
            },
            {// 4 Cherry Hill 50_000 4/24
                stepNumber:4,
                text:<p>
                    Near the end of the month, the death toll reaches 50,000. The reality of pandemic life begins to set in around the country.
                    <br/><br/>
                    In Central Park, the clearing around the Cherry Hill fountain is packed with a growing crowd.
                </p>,
            },
            {// 5 Frisbee Fields 150_000 7/29
                stepNumber:5,
                text:<p>
                    By late July, a major wave sweeps the South and the Sun Belt and 150,000 lives are now lost. The New York Times describes 100,000 deaths as an incalculable 
                    loss. Things progress for the worse. 
                    <br/><br/>
                    In Central Park, the crowd stretches down and densely occupies a lawn.
                </p>,
            },
            {// 6 Fields and Pitches 180_000 8/28
                stepNumber:6,
                text:<p>
                    Through another month, the count climbs another thirty thousand to 180,000. The crowd takes up residence in nearby fields and pitches. 
                </p>,
            },
            {// 7 Another crowd great lawn 270_000 12/1
                stepNumber:7,
                text:<p>
                     In December, the crowd occupies another large lawn, usually home to lounging sunbathers, frisbee players, and dogs enjoying a respite from metropolitan life.
                     <br/><br/>
                     270,000 in the US have been lost, and that number is set to double. 
                </p>,
            },
            {// 8 500_000
                stepNumber:8,
                text:<p>
                    Over recent months, the death toll crested half a million. <br/><br/>
                    Today we have lost <u>{props.sums && props.sums[props.sums.length-1].toLocaleString('en')}</u> people.
                    <br/><br/>
                    100,000 was described as incalculable. Now, it is nearly incomprehensible.  
                </p>,
            }
        ]
    }

    const [currSteps, setCurrSteps] = useState([])
    const [currIndex, setCurrIndex] = useState(0)
    useEffect(() => {
        setCurrSteps(Steps[props.city])
    }, [props.city])
    return (
        <>  
            <Map city={props.city} currIndex={currIndex} faded={currIndex === 0}/>
            <div>
                {currSteps.map(step => 
                    <Waypoint 
                        onEnter={() => setCurrIndex(step.stepNumber)}
                        >
                        <div className="step-text">{step?.text}</div>
                    </Waypoint>
                )}
            </div>
               
            <div className="step-text">These maps attempt to place this loss in space, around parks and cities you might know or remember, from
                    trips, growing up, or daily life. Remembering and facing the price of COVID-19 is not easy, but forgetting it may cost even more.
                    <br/><br/>
                    As of now, the state of the pandemic has improved through late January, February, and into early March. But this can change. Variants and
                    our behavior are unknowns in planning for the recovery. 
                    <br/><br/>
                    Take care, remember those lost, and do what you can to protect and support your community.   
            </div> 
            <div className="step-last">
                <a onClick={() => props.return()}>Click here to see this in a different place</a>
            </div>
            
        </>
    )
}